import { useFlags } from 'launchdarkly-react-client-sdk';
import { Building2, LogOut, Plug, Users } from 'lucide-react';
import { AvatarNameDescription } from '../../../design-system/avatar/avatar-name-description/avatar-name-description';
import { Badge } from '../../../design-system/badge/badge';
import { Button } from '../../../design-system/button/button';
import { Inline } from '../../../design-system/inline/inline';
import { Popover } from '../../../design-system/popover/popover';
import { Stack } from '../../../design-system/stack/stack';
import { DropdownMenuItem } from './dropdown-menu-item';
interface AvatarDropdownProps {
  avatarUrl?: string;
  name?: string;
  email?: string;
  onTeamClick: () => void;
  onSwitchOrgClick: () => void;
  onIntegrationsClick: () => void;
  logout: () => void;
}

const AvatarDropdown = ({
  avatarUrl,
  name,
  email,
  onTeamClick,
  onSwitchOrgClick,
  onIntegrationsClick,
  logout,
}: AvatarDropdownProps) => {
  const { isLongXeroFlowLive } = useFlags();

  return (
    <Popover
      align="end"
      triggerElement={
        <Button variant="ghost" size="icon" aria-label="Open user account menu">
          <img
            src={avatarUrl}
            alt=""
            loading="eager"
            fetchPriority="high"
            className="h-full w-full rounded-full object-cover"
          />
        </Button>
      }
      content={
        <div className="w-80">
          <Inline className="rounded-t-xl bg-background-sidenav p-5" justify="between">
            <AvatarNameDescription
              className="max-w-52"
              name={name ?? ''}
              avatar={avatarUrl ? { showAvatar: true, avatarUrl, size: 'sm' } : { showAvatar: false }}
              description={email ?? ''}
            />
            <Badge variant="neutral">Admin</Badge>
          </Inline>

          <Stack>
            <DropdownMenuItem icon={<Users className="h-full w-full" />} label="Team" onClick={onTeamClick} isFirst />

            <DropdownMenuItem
              icon={<Building2 className="h-full w-full" />}
              label="Switch Organisation"
              onClick={onSwitchOrgClick}
            />

            {isLongXeroFlowLive && (
              <DropdownMenuItem
                icon={<Plug className="h-full w-full" />}
                label="Integrations"
                onClick={onIntegrationsClick}
              />
            )}

            <DropdownMenuItem
              icon={<LogOut className="h-full w-full" />}
              label="Log Out"
              onClick={logout}
              isLast
              isDanger
            />
          </Stack>
        </div>
      }
      className="min-w-max"
    />
  );
};

export default AvatarDropdown;
